import React, { useState, useEffect } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
//Component
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import FormInput from "../../stories/hook-controls/input";
import FormCheckBox from "../../stories/hook-controls/checkbox";
import { Modal } from "../../stories/modal";
import { ReactTable } from "../../stories/react-table";
//Function
import { setDataToFormHookV2,isEmptyStr } from "../../utils/common-function";
import { getMasterColumns } from "./columns/role-maintenance";
import * as alertDialog from "../../utils/alert";
import { buildParameter } from "./parameter";
import { GetRoleMasterList } from "./api";
import { DeleteRole } from "./api";
import { SaveRole } from "./api";


function RoleMaintenance() {
  //Context

  //State
  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [DataList, setDataList] = useState([]);
  const [DataDetail, setDataDetail] = useState({});

  //Event
  const onOpenAddModal = () => {
    setOpenModal(true);
    setEditMode(false);
    setDataDetail(null);
  };
  const onOpenEditModal = () => {
    setOpenModal(true);
    setEditMode(true);
  };
  const onCloseModal = () => {
    setOpenModal(false);
  };

  //Function
  const Edit = (Detail) => {
    onOpenEditModal();
    setDataDetail(Detail);
  };

  const Delete = async (id, REFERENCED_USER) => {

    if (REFERENCED_USER > 0) return;

    let res = await alertDialog.ConfirmDelete();
    if (!res) return;

    let param = {
      ROLE_ID: id,
    };

    let api_res = await DeleteRole(param);
    if (!api_res) return;
    fetch();
    alertDialog.del_success();
  };

  //--------
  const fetch = async () => {
    let res = await GetRoleMasterList();
    setDataList(res);
  };
  useEffect(() => {
    fetch();
  }, []);

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Role Maintenance" 
        // add onClickAdd={onOpenAddModal}
        >
          <ReactTable
            keyField="ROLE_ID"
            data={DataList}
            columns={getMasterColumns(Edit, Delete)}
            addButton={true}
            handleOnAdd={(e) => onOpenAddModal()}
          />
        </BoxTemplate1>
        <DataModal
          editmode={editMode ? 1 : 0}
          open={openModal}
          onClose={onCloseModal}
          search={fetch}
          datadetail={DataDetail}
        />
      </BaseContainer>
    </div>
  );
}

function DataModal(props) {

  const { onClose } = props;
  const { open, editmode } = props;
  const { datadetail, search = () => {}, ...otherprops } = props;
  const method = useForm();
  const { setValue, getValues, setError, clearErrors, errors } = method;

  //Effect
  useEffect(() => {
    if (!open) return;
    if (editmode)
    {
      let data = setDataToFormHookV2(datadetail);
      setTimeout(() =>
        data?.forEach(({ name, value }) => setValue(name, value))
      );
    }
    else{
      setTimeout(() => setValue("ACTIVE", true));
    } 
  }, [datadetail, setValue, open, editmode]);

  const SaveDetail = async () => {

    clearErrors("ROLE_ID");
    const ROLE_ID = getValues().ROLE_ID;

    if (editmode === 0 && isEmptyStr(ROLE_ID)) {
      setError("ROLE_ID", {
        type: "manual",
        message: "The Role ID field is required",
      });
      return;
    }

    const ID = editmode ? datadetail.ROLE_ID : getValues().ROLE_ID;
    let param = buildParameter.SaveDetail(ID, getValues());
    let res = await SaveRole(param);
    if (res) {
      search();
      onClose();
      alertDialog.inform_success();
    }
  }

  return (
    <div>
      <Modal
        {...otherprops}
        onSave={SaveDetail}
        title={editmode ? "Edit Role" : "Add Role"}
      >
        <FormProvider {...method}>
          <Box m={3} maxWidth="500px" flexGrow={1} className="box-input">
            {editmode ? (
              <Typography variant="subtitle2" display="block" gutterBottom>
                Role ID : {datadetail.ROLE_ID}
              </Typography>
            ) : (
              <FormInput
                required
                name="ROLE_ID"
                label="Role ID"
                errorobj={errors}
              />
            )}
          </Box>
          <Box m={3} maxWidth="500px" flexGrow={1} className="box-input">
            <FormInput name="ROLE_DESC" label="Role Description" />
          </Box>
          <Box
            mt={3}
            ml={4.5}
            maxWidth="500px"
            flexGrow={1}
            style={{ marginTop: "0" }}
          >
            <FormCheckBox key="ACTIVE" name="ACTIVE" label="Active" />
          </Box>
        </FormProvider>
      </Modal>
    </div>
  );
}
export default RoleMaintenance;
